import React from 'react';
import {AppBar, Box, Button, IconButton, Toolbar, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {useApplicationContext} from '../../ApplicationContext';
import {SecuritySettings} from './SecuritySettings';

export const MfaRequiredGate: React.FC = () => {
    const context = useApplicationContext();
    const {t} = useTranslation();

    return (
        <Box sx={{flexGrow: 1, minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
            <AppBar position="static">
                <Toolbar>
                    <IconButton size="large" edge="start" color="inherit" sx={{mr: 2}}/>
                    <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                        {t('mfa.gate.appBarTitle')}
                    </Typography>
                    <Button color="inherit" onClick={context.signOut}>
                        {t('mfa.gate.logout')}
                    </Button>
                </Toolbar>
            </AppBar>
            <Box sx={{flex: 1}}>
                <SecuritySettings forced/>
            </Box>
        </Box>
    );
};

export default MfaRequiredGate;
